<template>
  <div class="w-full h-full horizontal layout center">
    <div class="w-full" v-if="isShowChart">
      <div class="mx-32 d-flex">
        <div class="flex-grow w-6/12">
          <Prompt
            v-for="(item, index) in prompts"
            :key="index"
            :color="item.color"
            :text="item.title"
            :index="item.index"
            position="left"
            :showAnswer="showAnswer"
            :hideConnect="!item.pairTitle"
            :bg-color="slideActive.baseColour"
          />
        </div>

        <div class="flex-grow w-6/12">
          <transition-group name="flip-list">
            <Prompt
              v-for="item in answersOptions"
              :key="item.id"
              :color="item.color"
              :text="item.pairTitle"
              :order="item.key"
              position="right"
              :showAnswer="showAnswer"
              :showAnswerColor="showAnswerColor"
              :class="{'promt-visible': item.hidden}"
              :bg-color="slideActive.baseColour"
            />
          </transition-group>
        </div>
      </div>
      <div class="match-answer horizontal layout center center-justified">
        <Answer v-if="canShowQuizResult" />
      </div>
    </div>

    <CanvasQuestionImage v-if="!isShowChart" />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Prompt from '@/components-v2/presentation-editor/match-pairs/Prompt.vue'
import Answer from '@/components-v2/presentation-editor/match-pairs/Answer.vue'
import CanvasQuestionImage from '@/components-v2/presentation-editor/middle/CanvasQuestionImage.vue'
import util from '@/util'
import EventBus from '@/eventBus'
import QuizStatuses from '@/constant/QuizStatuses'

export default {
  components: {
    Prompt,
    Answer,
    CanvasQuestionImage,
  },
  data() {
    return {
      answersOptions: [],
      showAnswer: false,
      showAnswerColor: false,
      prompts: [],
    }
  },
  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
      presentation: (state) => state.presentation,
    }),
    isShowChart() {
      const presenting = this.$store.getters.isPresenting
      const { slideActive } = this.$store.state
      const noQuestionImg = !slideActive.showQuestionImage || !slideActive.image

      if ((!presenting && noQuestionImg) || (slideActive.type === 'pickAnswer' && presenting && !this.$store.state.sharePresentation) || (slideActive.type === 'pickAnswer' && this.$store.state.sharePresentation && noQuestionImg)) {
        return true
      }
      return false
    },
    canShowQuizResult() {
      const isResultScreen = this.slideActive.quizStatus === QuizStatuses.RESULT_SCREEN
      if (!this.presentation.manualRevealCorrectAnswers) {
        return isResultScreen
      }
      return isResultScreen && this.slideActive.showCorrectOption
    },
  },
  watch: {
    'slideActive.quizStatus': function resultUpdated() {
      if (this.slideActive.quizStatus === QuizStatuses.RESULT_SCREEN) {
        setTimeout(() => {
          this.handleShowCorrectAnswer()
        }, 500)
      }
    },
    'slideActive.showCorrectOption': function watchShowCorrectOption(showCorrectOption) {
      if (showCorrectOption) {
        setTimeout(() => {
          this.handleShowCorrectAnswer()
        }, 500)
      }
    },
  },
  mounted() {
    this.updateSlideOption()
    EventBus.$on('match-pairs-change', () => {
      this.updateSlideOption()
      this.handleShowDefault()
    })
    this.handleShowDefault()
    if (this.$store.state.sharePresentation) {
      this.slideActive.quizStatus = 5
      this.handleShowCorrectAnswer()
    }
  },
  destroyed() {
    EventBus.$off('match-pairs-change')
  },
  methods: {
    ...mapActions(['updateSlideActiveAction']),
    handleShowDefault() {
      if (!this.isShowDefault()) return
      this.prompts = [
        {
          id: 1, index: 1, title: 'Prompt...', color: util.getAhaColor(1),
        },
        {
          id: 2, index: 2, title: 'Prompt...', color: util.getAhaColor(2),
        },
        {
          id: 3, index: 3, title: 'Prompt...', color: util.getAhaColor(3),
        },
        {
          id: 4, index: 4, title: 'Prompt...', color: util.getAhaColor(4),
        },
      ]
      this.answersOptions = [
        { id: 1, key: 'A', pairTitle: 'Answer...' },
        { id: 2, key: 'B', pairTitle: 'Answer...' },
        { id: 3, key: 'C', pairTitle: 'Answer...' },
        { id: 4, key: 'D', pairTitle: 'Answer...' },
      ]
    },
    isShowDefault() {
      let isShow = true
      this.slideActive.SlideOptions.forEach((item) => {
        if (item.title || item.pairTitle) isShow = false
      })
      return isShow
    },
    setKeyOption() {
      this.answersOptions.map((item, key) => {
        if (key === 0) item.key = 'A'
        if (key === 1) item.key = 'B'
        if (key === 2) item.key = 'C'
        if (key === 3) item.key = 'D'
        return item
      })
    },

    handleShowCorrectAnswer() {
      if (!this.canShowQuizResult) {
        return
      }
      this.prepareCorrectAnswer()
      setTimeout(() => {
        this.showAnswer = true
        setTimeout(() => {
          this.showAnswerColor = true
        }, 500)
      }, 1500)
    },
    prepareCorrectAnswer() {
      const listCorrect = []
      this.prompts.forEach((item) => {
        const index = this.answersOptions.findIndex((option) => {
          return option.id === item.id
        })

        if (index !== -1) {
          listCorrect.push(this.answersOptions[index])
        } else {
          const indexInSlideOption = this.getOptions().findIndex((option) => {
            return option.id === item.id
          })
          if (indexInSlideOption !== -1) {
            const optionInCorrect = this.getOptions()[indexInSlideOption]
            optionInCorrect.hidden = true
            listCorrect.push(optionInCorrect)
          }
        }
      })
      this.answersOptions.forEach((item) => {
        const index = this.prompts.findIndex((option) => {
          return option.id === item.id
        })
        if (index === -1) {
          listCorrect.push(item)
        }
      })
      this.answersOptions = listCorrect
    },
    getOptions() {
      return this.slideActive.SlideOptions.filter((item) => item.id)
    },
    updateSlideOption() {
      this.prompts = this.getOptions().filter((item) => item.title)
      this.prompts.map((item, key) => {
        item.index = key + 1
        item.color = util.getAhaColor(key)
        return item
      })
      this.answersOptions = util.shuffleArrayWithSeed(
        this.getOptions().filter((item) => item.pairTitle),
        this.slideActive.id,
      )
      this.setKeyOption()
    },
  },
}
</script>

<style lang="scss" scoped>
.flip-list-move {
  transition: transform 1.5s;
}
.match-answer {
  height: 50px;
  margin-top: 6px;
}

.promt-visible {
  visibility: hidden;
}
</style>
